import React from 'react';
import { cn } from '../../../../lib/utils';
import { getThinkingBubbleStyles, getThinkingDotsStyles } from './bubbleStyles';

const ChatThinking = () => {
  return (
    <div className="relative flex items-start mt-2 w-full">
      <div className={getThinkingBubbleStyles()}>
        <div className={getThinkingDotsStyles()}>
          {[0, 1, 2].map((index) => (
            <span
              key={index}
              className={cn(
                'w-2 h-2 rounded-full bg-muted-foreground opacity-70',
                'animate-pulse',
              )}
              style={{
                animationDelay: `${index * 0.2}s`,
                animationDuration: '1.5s',
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChatThinking;
